import {kmApiLink, Scenario} from "@pg-mono/km-routes";
import {Country} from "@pg-rp/common-types";

import {getIgnoredNotifyResponse} from "../../../store/utils/get_ignored_notify_response";
import {kmApi} from "../../km_app/api/km_api";
import {IVariables} from "../../km_app/state/variables_slice";
import {GetListMapRegionItemDto} from "../types/GetListMapRegionItemDto";
import {getAllRegionTypesFromVariable} from "../utils/get_all_region_types_from_variable";

interface IRequestParams {
    region?: number | number[];
    regionFullName?: string;
    country?: Country;
}

interface IResponse {
    results: GetListMapRegionItemDto[];
}

const multiRegionListLink = kmApiLink.regions.base(Scenario.REGION_LIST_MAP);
const SEARCH_REGIONS_LIMIT = 30;

export const getMapRegion = kmApi.injectEndpoints({
    endpoints: (build) => ({
        getMapRegions: build.query<IResponse, IRequestParams>({
            queryFn: async ({region, regionFullName, country}, {getState}, _extraOptions, baseQuery) => {
                if (!regionFullName && (!region || (Array.isArray(region) && region.length === 0))) {
                    return {
                        data: {
                            results: []
                        }
                    };
                }

                const allRegionTypeValues = getAllRegionTypesFromVariable(getState() as {variables: IVariables});
                const baseQueryResult = await baseQuery({
                    url: multiRegionListLink,
                    params: {
                        ...(regionFullName
                            ? {
                                  full_name: regionFullName
                              }
                            : {
                                  region
                              }),
                        country,
                        type: allRegionTypeValues,
                        page_size: SEARCH_REGIONS_LIMIT
                    }
                });

                if (baseQueryResult.error) {
                    if (!getIgnoredNotifyResponse(baseQueryResult.error, [400, 404]).ignoreNotify) {
                        return {
                            data: {
                                results: []
                            }
                        };
                    } else {
                        return {error: baseQueryResult.error};
                    }
                }

                return {data: baseQueryResult.data as IResponse};
            }
        })
    })
});

export const {useGetMapRegionsQuery, useLazyGetMapRegionsQuery} = getMapRegion;
import {kmApiLink, Scenario} from "@pg-mono/km-routes";
import {Country} from "@pg-rp/common-types";

import {getIgnoredNotifyResponse} from "../../../store/utils/get_ignored_notify_response";
import {kmApi} from "../../km_app/api/km_api";
import {IVariables} from "../../km_app/state/variables_slice";
import {GetListMapRegionItemDto} from "../types/GetListMapRegionItemDto";
import {getAllRegionTypesFromVariable} from "../utils/get_all_region_types_from_variable";

interface IRequestParams {
    region?: number | number[];
    regionFullName?: string;
    country?: Country;
}

interface IResponse {
    results: GetListMapRegionItemDto[];
}

const multiRegionListLink = kmApiLink.regions.base(Scenario.REGION_LIST_MAP);
const SEARCH_REGIONS_LIMIT = 30;

export const getMapRegion = kmApi.injectEndpoints({
    endpoints: (build) => ({
        getMapRegions: build.query<IResponse, IRequestParams>({
            queryFn: async ({region, regionFullName, country}, {getState}, _extraOptions, baseQuery) => {
                if (!regionFullName && (!region || (Array.isArray(region) && region.length === 0))) {
                    return {
                        data: {
                            results: []
                        }
                    };
                }

                const allRegionTypeValues = getAllRegionTypesFromVariable(getState() as {variables: IVariables});
                const baseQueryResult = await baseQuery({
                    url: multiRegionListLink,
                    params: {
                        ...(regionFullName
                            ? {
                                  full_name: regionFullName
                              }
                            : {
                                  region
                              }),
                        country,
                        type: allRegionTypeValues,
                        page_size: SEARCH_REGIONS_LIMIT
                    }
                });

                if (baseQueryResult.error) {
                    if (!getIgnoredNotifyResponse(baseQueryResult.error, [400, 404]).ignoreNotify) {
                        return {
                            data: {
                                results: []
                            }
                        };
                    } else {
                        return {error: baseQueryResult.error};
                    }
                }

                return {data: baseQueryResult.data as IResponse};
            }
        })
    })
});

export const {useGetMapRegionsQuery, useLazyGetMapRegionsQuery} = getMapRegion;
